import { contrast } from 'utilities/global';
import { MINIMUM_CONTRAST } from 'consts';

export const get100vhHeight = keyProp => `
    ${keyProp}: 100vh;
    ${keyProp}: calc(var(--vh, 1vh) * 100);
`;

export const isBelowMinContrast = backgroundColor => {
  const textContrast = contrast(backgroundColor, '#fff');
  const belowMinContrast = textContrast < MINIMUM_CONTRAST;
  return belowMinContrast;
};
